<template>
  <div class="variables-definitions">
    <label>{{ $t('analyses.definitionOfVariables') }}</label>

    <div class="variables-table">
      <div class="variables-header">
        <label>Variable</label>
        <label>{{ $t('analyses.analysisType') }}</label>
      </div>
    </div>

    <div class="content">
      <div
        v-for="(variable, index) in variables"
        :key="index"
        :index="index"
        v-bind="variable"
        class="item"
      >
        <div class="item-name">
          {{ variable.name }}
        </div>

        <div class="analysis-type">
          <v-select
            class="select-type"
            :placeholder="$t('analyses.selectAnalysis')"
            itemValue="ref"
            itemText="name"
            :items="analysisTypes"
            :value="variable.ref"
            @input="updateVariable(index, $event)"
          />

          <div
            class="remove-button"
            :class="[index < 1 ? 'disabled' : '' ]"
          >
            <v-btn
              icon
              @click="deleteVariable(index)"
            >
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <div class="add-button">
        <v-btn
          icon
          @click="addVariable"
        >
          <v-icon> mdi-plus </v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';


export default {
    name: 'DefintionOfVariables',

    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            variables: [],
            types: [],
        };
    },

    computed: {
        ...mapGetters([
            'userLang',
            'site',
            'hasPermission',
            'teamMainLang',
        ]),

        analysisTypes() {
            // Convert ids to refs:
            const withRefs = this.types.map(type => ({
                ref: type.id,
                name: type.name[this.userLang] || type.name[this.teamMainLang],
            }));

            // Sort alphabetically:
            return withRefs.sort((a, b) => a.name?.localeCompare(b?.name));
        },

    },

    watch: {
        list() {
            this.variables = [...this.list];
        },
    },

    async created() {
        await this.getTypes();

        this.variables = this.list.length
            // If the list provided is empty, initilize with default values:
            ? [...this.list]

            // Otherwise, load props into local state:
            : [{ name: 'A', ref: null }];
    },

    methods: {
        async getTypes(includeInactive = false) {
            const paramsPayload = { typeName: 'SimpleAnalysisType', includeInactive, pagination: false };
            const { data } = await this.$rq.getAnalysisTypes(paramsPayload);
            this.types = data.types;
        },
        duplicateChecking(charCode) {
            return this.variables.some(variable => variable.name === String.fromCharCode(charCode));
        },
        addVariable() {
            let nextCharCode = this.variables.length + 65;
            // Si la lettre est 'E (69)', on saute à 'F (70)'
            if (nextCharCode === 69) {
                nextCharCode += 1;
            }
            while (this.duplicateChecking(nextCharCode)) {
                nextCharCode += 1;
            }
            this.variables.push({
                name: String.fromCharCode(nextCharCode),
                ref: null,
            });

            this.$emit('onChange', this.variables);
        },

        // Update variable's analysis type by index:
        updateVariable(index, ref) {
            this.variables[index] = { ...this.variables[index], ref };
            this.variables = [...this.variables];

            this.$emit('onChange', this.variables);
        },

        deleteVariable(index) {
            this.variables.splice(index, 1);

            this.$emit('onChange', this.variables);
        },
    },
};
</script>

<style lang="scss" scoped>
.variables-definitions {
    display: flex;
    flex-direction: column;
    justify-content: center;

    width: 100%;
    color: #26384b;
    font-size: 14px;
}

.variables-definitions label {
    font-size: 14px;
}

.variables-table {
    display: flex;
    flex-direction: column;

    width: 100%;
}

.variables-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;

    width: 100%;
    padding: 16px;
    margin-top: 10px;

    border-radius: 6px 6px 0px 0px;
    background: #26384b;
}

.variables-header label {
    color: #FFF;
    font-size: 14px;
    width: 100%;
    max-width: 300px
}

.content {
    display: flex;
    flex-direction: column;

    width: 100%;
    border: 1px solid #26384b;
    border-radius: 0px 0px 6px 6px;
}

.item {
    display: flex;

    width: 100%;
    height: 100%;
    max-height: 55px;
    border-bottom: 1px solid #26384b;
}

.item-name {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 300px;
    text-align: center;

    border-right: 1px solid #26384b;
    text-align: center;
}

.analysis-type {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 10px 0px 0px 10px;
    width: 100%;
}

.select-type .v-icon {
    background: #FFF !important;
    color: #26384b !important;
    font-size: 50px !important;
}

.add-button {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    max-width: 300px;
    padding: 24px;
    border-radius: none;
    border-right: 1px solid #26384b;
}

.remove-button {
    display: flex;
    justify-content: center;
    align-items: center;


    height: 100%;
    width: 100%;
    max-width: 100px;
}

.remove-button.disabled {
    pointer-events: none;
    opacity: 0.00;
}

.content .v-icon {
    width: 20px;
    height: 20px;

    font-size: 16px;
    border-radius: 50px;
    color: #fff;

    background: #26384b;
}


</style>

<style>
.analysis-type .v-input__slot:before {
    border-style: none !important;
}

.analysis-type .v-input__slot:after {
    border-style: none !important;
}

</style>
